module.exports = __webpack_public_path__ + "img/logo.52c634ce.jpg";